import { NewOrderAttributes, TNewOrderAttributes } from "@/entities/new-order";

const ATTRIBUTES_VALUES: Record<TNewOrderAttributes, number> = {
  [NewOrderAttributes.Distribute]: 1 << 0,
  [NewOrderAttributes.ConsoleVisible]: 1 << 1,
  [NewOrderAttributes.La1day]: 1 << 2,
  [NewOrderAttributes.La2day]: 1 << 3,
  [NewOrderAttributes.La3day]: 1 << 4,
  [NewOrderAttributes.La4day]: 1 << 5,
  [NewOrderAttributes.La5day]: 1 << 6,
  [NewOrderAttributes.La6day]: 1 << 7,
  [NewOrderAttributes.La7day]: 1 << 8,
  [NewOrderAttributes.La8day]: 1 << 9,
  [NewOrderAttributes.La9day]: 1 << 10,
  [NewOrderAttributes.La10day]: 1 << 11,
  [NewOrderAttributes.La11day]: 1 << 12,
  [NewOrderAttributes.La12day]: 1 << 13,
  [NewOrderAttributes.La13day]: 1 << 14,
  [NewOrderAttributes.La14day]: 1 << 15,
  [NewOrderAttributes.Day]: 1 << 16,
  [NewOrderAttributes.Retention]: 1 << 17,
};

export const getParsedAttributes = (
  attributesValue: number
): TNewOrderAttributes[] => {
  const list: TNewOrderAttributes[] = [];

  // Итерируемся по ключам объекта NewOrderAttributes
  for (const key in NewOrderAttributes) {
    // Получаем значение (например, "distribute" для ключа "Distribute")
    const attributeValue =
      NewOrderAttributes[key as keyof typeof NewOrderAttributes];

    // Проверяем битовую маску
    if ((attributesValue & ATTRIBUTES_VALUES[attributeValue]) !== 0) {
      list.push(attributeValue);
    }
  }
  return list;
};
